@if (outputPrefix()) {
    <p-inputgroup>
        <p-inputgroup-addon>
            {{ outputPrefix().label }}
        </p-inputgroup-addon>
        <ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
    </p-inputgroup>
} @else {
    <ng-container *ngTemplateOutlet="dropdownTemplate"></ng-container>
}

<ng-template #dropdownTemplate>
    <p-multiselect
        class="w-full"
        display="chip"
        [showClear]="true"
        [options]="items()"
        optionValue="value"
        optionLabel="label"
        [(ngModel)]="value"
        [ngModelOptions]="{standalone: true}"
        (onChange)="valueChange($event)"
        (onTouched)="onTouched?.()"
        (onClear)="valueChange({ value: [] })"
        [disabled]="disabled()"
        appendTo="body"
    >
        <ng-template #selecteditems let-selectedItems let-removeChip="removeChip">
            @if((selectedItems?.length ?? 0) == 0) {
                @for (item of value(); track $index) {
                    <p-skeleton height="24px" [width]="'90px'" styleClass="m-0 p-0" />
                }
            }
            @else {
                @for (item of selectedItems; track $index) {
                    @let itemData = getItemForValue(item.value);
                    <p-chip removable (onRemove)="removeChip(item, $event); unselectItem(item.value);">
                        {{ itemData.label }}
                    </p-chip>
                }
            }
        </ng-template>
    </p-multiselect>
</ng-template>
